import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Box, Typography, Grid } from '@mui/material';
import CustomFieldValue from './CustomFieldValue';

const customFieldSx = {
    border: (theme) => `1px solid ${theme.palette.divider}`,
    borderRadius: '8px',
    p: 2,
};

const CustomField = ({ customField, fieldIndex }) => {
    const { control } = useFormContext();
    const fieldName = `custom_fields.${fieldIndex}.value`;
    const idName = `custom_fields.${fieldIndex}.custom_field_id`;
    const dataTypeName = `custom_fields.${fieldIndex}.data_type`;
    const minName = `custom_fields.${fieldIndex}.min`;
    const maxName = `custom_fields.${fieldIndex}.max`;
    const optionsName = `custom_fields.${fieldIndex}.options`;

    return (
        <Box sx={customFieldSx}>
            <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} md={8} sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 1 }}>
                    <Box sx={{ mr: 2, width: '25%' }}>
                        {/* The category is rendered as the group subheader these rows sit under. */}
                        <Typography variant="body1">{customField.name}</Typography>
                    </Box>
                    <input type="hidden" {...control.register(idName)} />
                    <input type="hidden" {...control.register(dataTypeName)} />
                    <input type="hidden" {...control.register(minName)} />
                    <input type="hidden" {...control.register(maxName)} />
                    <input type="hidden" {...control.register(optionsName)} />
                    <Box sx={{ width: '50%' }}>
                        <CustomFieldValue customField={customField} fieldName={fieldName} />
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};

export default CustomField;
